<div
  class="nimbus-tooltip"
  [matTooltip]="text"
  [matTooltipPosition]="matTooltipPosition"
  [matTooltipPositionAtOrigin]="true"
  [matTooltipShowDelay]="showDelay"
  [matTooltipHideDelay]="0"
  [matTooltipClass]="matTooltipClass"
>
  &nbsp;
</div>
